import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { ActivatedRoute, RouterModule } from "@angular/router";
import type { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	standalone: true,
	selector: "obg-app-my-offers-bonus-details",
	templateUrl: "./my-offers-bonus-details.component.html",
	styleUrls: ["./my-offers-bonus-details.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		"[class.obg-app-my-offers-bonus-details]": "true",
	},
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [CommonModule, RouterModule],
})
export class MyOffersBonusDetailsComponent {
	protected readonly bonusId$: Observable<string | null>;

	constructor(private readonly activatedRoute: ActivatedRoute) {
		this.bonusId$ = this.activatedRoute.paramMap.pipe(map((params) => params.get("bonusId")));
	}
}
